export class AppConfig {
  static get WEBSITE_BASE_URL(): string {
    return 'https://empion.io';
  }

  static get HUBSPOT_WEBSITE_BASE_URL_EN(): string {
    return 'https://empion.io/en/contact/talents';
  }

  static get HUBSPOT_WEBSITE_BASE_URL_DE(): string {
    return 'https://empion.io/kontakt/talente';
  }

  static get BOOK_CALL_COMPANIES_URL_DE(): string {
    return 'https://empion.io/kontakt';
  }

  static get BOOK_CALL_COMPANIES_URL_EN(): string {
    return 'https://empion.io/en/contact';
  }

  static get PLATFORM_BASE_URL(): string {
    const baseURL = process.env.REACT_APP_PLATFORM_BASE_URL || 'http://localhost:5173';
    return baseURL;
  }

  static get DASHBOARD_PATH(): string {
    return '/dashboard';
  }

  static get APPLICANT_DASHBOARD_PATH(): string {
    return '/applicant/dashboard';
  }

  static get COMPANY_ANALYTICS_DASHBOARD_PATH(): string {
    return '/company/analytics';
  }

  static get COMPANY_CAMPAIGNS_PATH(): string {
    return '/company/campaigns';
  }

  static get APPLICANT_CULTURE_PATH(): string {
    return '/applicant/culture';
  }
  static get APPLICANT_MATCHES_PATH(): string {
    return '/applicant/matches';
  }

  static get SIGN_UP_PATH(): string {
    return '/talent/sign-up/';
  }

  static get COMPANY_SIGN_UP_PATH(): string {
    return '/company/sign-up';
  }

  static get LOGIN_PATH(): string {
    return '/login';
  }

  static get LOGOUT_PATH(): string {
    return '/logout';
  }

  static get ACCOUNT_SETTINGS_PATH(): string {
    return '/account/settings';
  }

  static get PASSWORD_RESET_PATH(): string {
    return '/password/reset';
  }

  static get FORGOT_PASSWORD_PATH(): string {
    return '/password/request-reset';
  }

  static get HOME_PATH(): string {
    return '/';
  }

  static get PROFILE_PATH(): string {
    return '/profile';
  }

  static get COMPANY_PROFILE_PATH(): string {
    return '/company/profile';
  }

  static get COMPANY_CULTURE_CHECK_PATH(): string {
    return '/company/culture_check';
  }

  static get APPLICANT_PROFILE_PATH(): string {
    return '/applicant/profile';
  }

  static get TALENT_SURVEY_WITH_ID_PATH(): string {
    return '/talent/survey';
  }

  static get APPLICANT_ONBOARDING_PATH(): string {
    return '/applicant/onboarding';
  }

  static get COMPANY_ADMIN_RECRUITING_DASHBOARD_PATH(): string {
    return '/company/recruiting/dashboard';
  }

  static get COMPANY_ADMIN_RECRUITING_MATCHES_PATH(): string {
    return '/company/recruiting/matches';
  }

  static get COMPANY_ADMIN_RECRUITING_TALENT_POOL_PATH(): string {
    return '/company/recruiting/talent-pool';
  }

  static get COMPANY_ADMIN_RECRUITING_TALENT_POOL_PROFILE_PATH(): string {
    return '/company/recruiting/talent-pool/profile';
  }

  /**
   * `per_page` default value for pagination.
   */
  static get PAGINATION_PER_PAGE(): number {
    return 25;
  }

  static get COMPANY_ADMIN_RECRUITING_JOB_POSTINGS_PATH(): string {
    return '/company/recruiting/job-postings';
  }

  static get COMPANY_ADMIN_RECRUITING_INBOX_PATH(): string {
    return '/company/recruiting/inbox';
  }

  static get COMPANY_ADMIN_CULTURE_ANALYTICS_PATH(): string {
    return '/company/culture/analytics';
  }

  static get COMPANY_ADMIN_CULTURE_SURVEYS_PATH(): string {
    return '/company/culture/surveys';
  }

  static get COMPANY_ADMIN_CULTURE_COMPARISON_PATH(): string {
    return '/company/culture/comparison';
  }

  static get COMPANY_WORKFORCE_ANALYSIS_DASHBOARD_PATH(): string {
    return '/company/workforce/analysis/dashboard';
  }

  static get COMPANY_WORKFORCE_ANALYSIS_PROFILES_PATH(): string {
    return '/company/workforce/analysis/profiles';
  }

  static get COMPANY_WORKFORCE_ANALYSIS_DEPARTMENT_HEALTH_PATH(): string {
    return '/company/workforce/analysis/department-health';
  }

  static get COMPANY_WORKFORCE_CONFIGURATION_TARGET_PROFILES_PATH(): string {
    return '/company/workforce/configuration/target-profiles';
  }

  static get QUESTIONNAIRE_PATH(): string {
    return '/company/culture-survey-questionnaire';
  }

  static get QUESTIONNAIRE_WELCOME_PATH(): string {
    return '/company/culture-survey';
  }

  static get COMPANY_NOT_SIGNED_PATH(): string {
    return '/company/not-signed';
  }

  static get USER_CONFIRM_EMAIL_PATH(): string {
    return '/account/confirm-account';
  }
  static get DEFAULT_LOCALE(): string {
    return 'en';
  }

  static get APPLICANT_PROFILE_PICTURE_MAX_SIZE_IN_BYTES(): number {
    return 1 * 1024 * 1024;
  }

  static get APPLICANT_PROFILE_PICTURE_MAX_SIZE_IN_MB(): number {
    return 1; // 1MB
  }

  static get APPLICANT_RESUME_FILE_MAX_SIZE_IN_BYTES(): number {
    return 1 * 1024 * 1024;
  }

  static get APPLICANT_RESUME_FILE_MAX_SIZE_IN_MB(): number {
    return 1; // 1MB
  }

  static get LOCAL_STORAGE_LINKEDIN_AUTH_CODE_KEY(): string {
    return 'MjF3N3V4NzV3eWJ6Yg';
  }

  static get LOCAL_STORAGE_LINKEDIN_STATE_KEY(): string {
    return 'zV3eWJ6YgBmRmN3V4N';
  }

  static get LOCAL_STORAGE_LINKEDIN_ERROR_KEY(): string {
    return 'mRm3Vg4NzVB3eWJ6YN';
  }

  static get TREATMENT_PRONOUN_OPTIONS_EN(): string[] {
    return ['none', 'miss', 'mr', 'ms', 'mrs'];
  }

  static get TREATMENT_PRONOUN_OPTIONS_DE(): string[] {
    return ['none', 'mr', 'ms'];
  }

  static get LOCAL_STORAGE_COMPANY_SURVEY_QUESTIONNAIRE_RESETED(): string {
    return 'ekf';
  }

  static get LOCAL_STORAGE_COMPANY_SURVEY_QUESTIONNAIRE_RESOURCE_ID_KEY(): string {
    return 'ZBGUg9tLPsjfulkeU3NdJw';
  }

  static get LOCAL_STORAGE_COMPANY_SURVEY_QUESTIONNAIRE_KEY(): string {
    return 'z0TfYyvyTRo8KUBajyvKaw';
  }

  static get COMPANY_SURVEY_QUESTIONNAIRE_PATH(): string {
    return '/company/culture-survey-questionnaire';
  }

  static get LOCAL_STORAGE_QUESTIONNAIRE_DEMOGRAPHICS_RESOURCE_ID_KEY(): string {
    return 'ffBGUg9214tLPsjfulkefU3Nf';
  }

  static get LOCAL_STORAGE_SURVEY_CODES_KEY(): string {
    return 'ZPny3RzdJtyplf5nGHA_5Q';
  }

  static get LOCAL_STORAGE_LAST_SURVEY_CODE_KEY(): string {
    return 'ZPny3RzdJtyplf5nGHA_5Q_started';
  }

  static get LOCAL_STORAGE_QUESTIONNAIRE_BENEFITS_SUBMITTED_KEY(): string {
    return 'goBG32214tLPsjfulkdfefU3Nf';
  }

  static get LOCAL_STORAGE_CULTURAL_ITEM_CURRENT_INDEX_KEY(): string {
    return 'f5n';
  }

  static get LOCAL_STORAGE_CULTURAL_ITEMS_METADATA_KEY(): string {
    return 'b5n';
  }

  static get LOCAL_STORAGE_QUESTIONNAIRE_DESIRED_BENEFITS_SUBMITTED_KEY(): string {
    return 'b5p';
  }

  static get LOCAL_STORAGE_QUESTIONNAIRE_CULTURAL_ITEMS_SUBMITTED_KEY(): string {
    return 'b5e';
  }

  static get LOCAL_STORAGE_QUESTIONNAIRE_DREAM_EMPLOYER_QUESTIONS_SUBMITTED_KEY(): string {
    return 'b5s';
  }

  static get LOCAL_STORAGE_DREAM_EMPLOYER_ITEMS_METADATA_KEY(): string {
    return 'b5t';
  }

  static get LOCAL_STORAGE_QUESTIONNAIRE_HAPPINESS_QUESTIONS_SUBMITTED_KEY(): string {
    return 'b5u';
  }

  static get LOCAL_STORAGE_HAPPINESS_ITEMS_METADATA_KEY(): string {
    return 'b5i';
  }

  static get LOCAL_STORAGE_QUESTIONNAIRE_TOP_STRENGTHS_SUBMITTED_KEY(): string {
    return 'b5o';
  }

  static get LOCAL_STORAGE_LINKEDIN_PUBLIC_PROFILE_URL(): string {
    return 'c1a';
  }

  static get LOCAL_STORAGE_LINKEDIN_PUBLIC_PICTURE_URL(): string {
    return 'c1b';
  }

  static get LOCAL_STORAGE_SESSION_EXPIRED_KEY(): string {
    return 'b5a';
  }
}
